import type { DisplayViewEmployeeViewModel, DisplayViewEquipmentViewModel, DisplayViewPlaceholderViewModel, DisplayViewResourceViewModel, DisplayViewTemporaryEmployeeBaseVM } from 'ab-viewModels/scheduleBoardDisplayView.viewModel';

export function isDisplayViewEmployeeViewModel(resource: DisplayViewResourceViewModel): resource is DisplayViewEmployeeViewModel {
	return (resource as DisplayViewEmployeeViewModel).employeeId !== undefined;
}

export function isDisplayViewEquipmentViewModel(resource: DisplayViewResourceViewModel): resource is DisplayViewEquipmentViewModel {
	return (resource as DisplayViewEquipmentViewModel).equipmentId !== undefined;
}

export function isDisplayViewPlaceholderViewModel(resource: DisplayViewResourceViewModel): resource is DisplayViewPlaceholderViewModel {
	return (resource as DisplayViewPlaceholderViewModel).placeholderId !== undefined;
}

export function isDisplayViewTemporaryEmployeeViewModel(resource: DisplayViewResourceViewModel): resource is DisplayViewTemporaryEmployeeBaseVM {
	return (resource as DisplayViewTemporaryEmployeeBaseVM).temporaryEmployeeId !== undefined;
}
